import React from "react";



const Copyright = () => {

  return (
    <div className="d-flex align-items-center flex-column"
      style={{
        margin: "0px auto",
        padding: "0px auto",
        wordBreak: "break-word",
        textAlign: "center",
        backgroundColor: "white",
        fontWeight: "bold",
      }}
    >
      Copyright © 2022 Ecole doctorale. Tout droit reservés
      
  
    </div>
  );
};

export default Copyright;
